<template>
    <a-table
        ref="childTable"
        row-key="customerCourseId"
        class="childTable"
        :row-selection="childRowKeys"
        :columns="columns"
        :data-source="dataSource"
        :pagination="false">
        <span slot="progress" slot-scope="text, record">
            <a-progress :percent="text.progress" />
        </span>
    </a-table>
</template>

<script>
export default {
    name:'ChildTable',
    props: {dataSource: Array, selectUser: Array, disabled: Boolean, columns:Array},
    data(){
        return{
            
        }
    },
    created(){
        console.log(this.selectUser);
    },
    computed:{
        childRowKeys(){
            return {
                type: "radio",
                selectedRowKeys: this.selectUser,
                onChange: (selectedRowKeys, selectedRows) => {
                    this.selectUser = selectedRowKeys;
                    this.$emit("selectUserChange", selectedRowKeys, selectedRows);
                }
            };
        },
    }
}
</script>

<style>

</style>